import script from "./px-table.vue?vue&type=script&lang=ts&setup=true"
export * from "./px-table.vue?vue&type=script&lang=ts&setup=true"

import "./px-table.vue?vue&type=style&index=0&id=3d60a44f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d60a44f"]])

export default __exports__